module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icons-grid-section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between"
  }, _vm._l((_vm.gridElements), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-sm col-md-4 single-item"
    }, [_c('div', {
      staticClass: "w-75 d-flex flex-column mx-auto align-items-center h-100"
    }, [_c('img', {
      staticClass: "mb-4",
      attrs: {
        "src": ("/static/assets/imgs/industries/" + (item.graphic)),
        "alt": "Icon"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "text-center mb-0"
    }, [_vm._v(_vm._s(item.text))])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0605ad6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/industries/IconsGrid.vue
// module id = 2017
// module chunks = 5